// Imperative entry point for the global ShareModal singleton mounted at
// the AppShell root. Lets ephemeral surfaces (post-trade toast, etc.)
// pop the full modal without owning a trigger element.

import { type ShareModalRequest, useShareModalStore } from '@/stores/share-modal';

/** Pop the global ShareModal with the given request. The next call
 *  replaces any in-flight request — there's only ever one share modal on
 *  screen. */
export function openShareModal(request: ShareModalRequest): void {
  useShareModalStore.getState().openShareModal(request);
}
